export const MAGIC_EDIT_MASK_HINT_DISMISSED_KEY = 'magic-edit-mask-hint-dismissed';
